import TextFitnessMeta from './TextFitnessMeta'

export default TextFitnessMeta
// eslint-disable-next-line import/export
export * from './TextFitnessMeta'
